import React, { FunctionComponent, useState } from "react";
import { Grid, IconButton, MuiThemeProvider, Table, Tooltip } from "@material-ui/core";
import PrintIcon from '@material-ui/icons/Print';
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../useTableStyle";
import { SuspendedVoucher } from "./SuspendedVoucher";
import { ThemeProvider } from "@mui/material/styles";

interface BillProps {
  suspendedBillDetails: Array<object>;
  billDetails: any;
  backToList: () => void;
  searchView:boolean;
  voucherValidity:string;
  listType:string;
}
export const SuspendedBillDetails: FunctionComponent<BillProps> = ({
  suspendedBillDetails,
  billDetails,
  backToList,
  searchView,
  voucherValidity,
  listType
}) => {
  const getMuiTheme = useTableStyles();
  const [voucherFlag, setVoucherFlag] = useState<boolean>(false);

  const columns = [
    "Item",
    "Item Code",
    "Plucode",
    "Total Quantity",
    "Unit Price",
    "Total Price",
    "Type"
  ];

  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: true,
      yAxis: true,
    },
    // fixedHeader: true,
    isRowSelectable: function () {
      return false;
    },
    /* print button visibility according to current day */
    customToolbar: () => <Tooltip title={"Print"}>
         {searchView || listType==="yearly" || billDetails.status==="resumed"?<div></div>:(
          <IconButton onClick={() => { setVoucherFlag(true) }}>
          <PrintIcon  color="secondary"/>
         </IconButton>
         )}
         
      </Tooltip>
  };

  const cancelPrint = () => {
    setVoucherFlag(false);
  }

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justify="space-between"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Bill Item Details"}
              data={suspendedBillDetails?.map((item: any) => {
                return [
                  item.product_name,
                  item.product_code,
                  item.product_ref_plu===null?item.pro_plu:item.product_ref_plu,
                  item.total_quantity,
                  item.unit_price,
                  item.total_price,
                  item.uom_code
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
      </Grid>
      {voucherFlag ? (
        <SuspendedVoucher
          voucherFlag={voucherFlag}
          billDetails={billDetails}
          backToList={backToList}
          cancelPrint={cancelPrint}
          voucherValidity={voucherValidity}
        />
      ) : ""}
    </Grid>
  );
};
